import { MDRType } from 'containers/Esrs/pieces/DisclosureRequirements/MDR/MDRData';
import { Paragraph } from 'docx';
import { ActionFieldsFragment_, QuestionType_Enum_, TargetFieldsFragment_ } from 'models';
import { TextStyle } from '../reportThemes';
import { EsrsReportStandard } from '../../Report.types';
import { mapUnitToCompanyCurrency } from 'containers/Esrs/utils';
import { sanitizeText } from '../report-helper-functions';

export const createMDR = (data: {
  mdr: MDRType & { value?: string };
  target?: TargetFieldsFragment_;
  action?: ActionFieldsFragment_;
}) => {
  const { mdr, target, action } = data;
  const title = mdr.title as string;

  const titleParagraph = new Paragraph({
    text: title,
    style: TextStyle.h4,
    spacing: {
      after: 100,
    },
  });

  const field = mdr?.secondField ?? mdr.field;
  const fieldAnswer = !!target
    ? target?.[field as keyof TargetFieldsFragment_]
    : action?.[field as keyof ActionFieldsFragment_];
  const answer = mdr?.value ?? fieldAnswer;
  const isNumeric = mdr.type === 'Number' || (!isNaN(answer) && !isNaN(parseFloat(answer)));

  const answerParagraphs = new Paragraph({
    text: !!answer ? sanitizeText(String(answer)) : 'No answer provided.',
    style: !!answer ? TextStyle.body : TextStyle.bodyItalic,
    spacing: {
      afterAutoSpacing: true,
    },
  });
  if (mdr.field === 'none') return [titleParagraph];
  return !!answer && !isNumeric ? [answerParagraphs] : [titleParagraph, answerParagraphs];
};

export const createTargetActionQuestion = (
  question:
    | EsrsReportStandard['actionQuestions'][number]
    | EsrsReportStandard['targetQuestions'][number],
  answers: any,
  companyCurrency: string,
  indent?: boolean
) => {
  const title = question.title;

  const titleParagraph = new Paragraph({
    text: title,
    style: TextStyle.h4,
    spacing: {
      after: 100,
    },
    indent: {
      left: indent ? 400 : 0,
    },
  });

  const answer = answers?.[question.reference]?.value;
  const isNumeric = question.questionType === QuestionType_Enum_.Decimal_;

  const unit = mapUnitToCompanyCurrency(question.unit, companyCurrency);
  const answerWithUnit = sanitizeText(isNumeric ? String(`${unit} ${answer}`) : String(answer));

  const answerParagraphs = new Paragraph({
    text: !!answer ? answerWithUnit : 'No answer provided.',
    style: !!answer ? TextStyle.body : TextStyle.bodyItalic,
    spacing: {
      afterAutoSpacing: true,
    },
    indent: {
      left: indent ? 400 : 0,
    },
  });

  return !!answer && !isNumeric ? [answerParagraphs] : [titleParagraph, answerParagraphs];
};
